import { Injectable, ErrorHandler, Injector } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class ToastErrorHandler extends ErrorHandler {

  constructor(private injector: Injector) {
    super();
  }

  handleError(errorResp: /*Error |*/ HttpErrorResponse) {
    const toastrService = this.injector.get(ToastrService);

    let displayMessage = 'An error occurred.';

    setTimeout(() => {
      if (errorResp.status >= 500 /* 500, 504 */) {
        toastrService.error(displayMessage, 'Unexpected Error', { tapToDismiss: true });
      } else if (errorResp.status === 401) {
        toastrService.warning('You are not authorized', 'Authorization', { tapToDismiss: true });
      } else if (errorResp.status === 400) {
        if (errorResp.error.errors && errorResp.error.errors.length && errorResp.error.errors[0].message)
          toastrService.warning(errorResp.error.errors[0].message, 'Warning', { tapToDismiss: true });// cap hpi - Business Error Response
        else if (errorResp.error.errors && errorResp.error.errors) {
          var obj = errorResp.error.errors;

          //skip errors with $(Model State Errors) for now
          if (Object.keys(obj)[0].indexOf('$') === 0) {
            //console.log('error with $', Object.keys(obj)[0]);
          } else {
            toastrService.warning(obj[Object.keys(obj)[0]], 'Warning', { tapToDismiss: true });// Model State Errors
          }

        } else
          toastrService.warning(errorResp.statusText, 'Warning', { tapToDismiss: true });
      } else if (errorResp.status === 404) {
        toastrService.warning(errorResp.statusText, 'Warning ' + errorResp.status, { tapToDismiss: true });
      }
      else {
        //toastrService.warning('A minor error happened', 'Warning ' + errorResp.status, { tapToDismiss: true });
        console.log('A minor error happened', errorResp);
      }
    });



    super.handleError(errorResp);
  }
}
